import { appstr } from "./appstr";
import { enumBookType, enumElementLayer, enumPageStep, enumXMLType } from "../constants";
import { Globals } from "../CoreApp/Globals";
import { doRenderXML } from "./doRenderXML";
import { FinishPostBook } from "./FinishPostBook";
import { updateXMLRenderStatus } from "./updateXMLRenderStatus";
import { doUploadPubContent } from "./doUploadPubContent";
import { endprtimer } from "./endprtimer";
import { wait } from "./wait";

export function doPageRender() {
  if (Globals._bookRenderInfo == null) return;

  if (Globals._uploadPubContent) {
    doUploadPubContent();
    return;
  }

  if (Globals._pubPerf) console.log("Enter doPageRender");

  var g = Globals._bookRenderInfo;

  // Get next page to render
  var pageIndex;
  if (g.fWorkingStep == enumPageStep.masterStep) {
    pageIndex = g.fPageRetryQ.shift();
    if (pageIndex != null && Globals._pubPerf)
      console.log("Rendering Background:" + pageIndex.toString());
  } else {
    pageIndex = g.fWorkingPage;
    if (Globals._pubPerf) console.log("Rendering Content Page:" + pageIndex.toString());
  }

  // We're done - no more pages to render
  if (pageIndex == null) {
    var e = endprtimer();
    if (Globals._pubPerf) console.log("Done rendering pages:" + e.toString());

    var oType = g.fPubPanel.GetXMLOutputType();
    var pmessage = "";
    switch (oType) {
      case enumXMLType.PDF:
        pmessage = "generatepdf";
        break;
      case enumXMLType.PPT:
        if (g.fPubPanel.fBookType == enumBookType.ppt) pmessage = "generateppt";
        else pmessage = "generategoogleslides";
        break;
    }
    g.fPubPanel.UpdateProgress2(appstr(pmessage), true);

    setTimeout(function () {
      FinishPostBook();
    }, 1);
    //var pp = g.fPubPanel;
    //pp.FinishPostBook();
    return;
  }

  var waitTime = 10;
  var picFault = 0;

  if (g.fWorkingStep == enumPageStep.masterStep) {
    picFault = doRenderXML(pageIndex, enumElementLayer.master);
    if (picFault == 0) g.fWorkingStep = enumPageStep.contentStep;
    else waitTime = 250;
  } else if (g.fWorkingStep == enumPageStep.contentStep) {
    picFault = doRenderXML(pageIndex, enumElementLayer.content);
    if (picFault == 0) {
      g.fWorkingStep = enumPageStep.masterStep;
      var workingPage = g.fWorkingPage;
      var pageSet = 50;
      if (g.fNumPages > pageSet && workingPage > 0 && workingPage % pageSet == 0)
        Globals._uploadPubContent = true;
    } else waitTime = 150 * Math.min(picFault, 8);
  }

  updateXMLRenderStatus();

  if (Globals._pubPerf)
    console.log("Schedule Next doPageRender - Pic Fault:" + picFault.toString());
  setTimeout(function () {
    doPageRender();
  }, waitTime);
}
